"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.hashPhone = exports.hashEmail = exports.digest = void 0;
var md5 = require("blueimp-md5");
var HASHING_SALT = '@@@wix-D15BA8F5-3031-42CA-BD43-0B68F418B2F0@@@';
var PHONE_NUM_DIGITS_TO_HASH = 5;
function digest(str) {
    return md5(str + HASHING_SALT);
}
exports.digest = digest;
function hashEmail(email) {
    var pos = email.lastIndexOf('@');
    var username = email.substr(0, pos);
    var provider = email.substr(pos + 1);
    if (provider !== 'wix.com') {
        username = digest(username);
    }
    return username + "@" + provider;
}
exports.hashEmail = hashEmail;
function hashPhone(phone) {
    var phoneHash = digest(phone);
    var originalPart = phone.substr(0, phone.length - PHONE_NUM_DIGITS_TO_HASH);
    var hashedPart = '';
    for (var i = 0; i < phoneHash.length && hashedPart.length < PHONE_NUM_DIGITS_TO_HASH; i++) {
        if (!isNaN(phoneHash[i])) {
            hashedPart += phoneHash[i];
        }
    }
    return "" + originalPart + hashedPart;
}
exports.hashPhone = hashPhone;
//# sourceMappingURL=hashers.js.map